import React, { useState, useEffect } from "react";
import {
  PrintOrderNumberLabel,PrintOrderNumberLabelsBatch,
  PrintSampleLabel,
  PrintCheckInLabel,
  sampleInfo,
} from "../../services/barcodeService";
import {
  CreateOrder,
  GetSampleIdsForOrderSamples,
} from "../../services/orderService";
import NewOrderForm from "./NewOrderForm";
import { appInsights } from "../../services/appInisights";
import { NotificationManager } from "react-notifications";
import {
  GetLastUser,
  SetLastUser,
  GetUsers,
  GetEtkKits,
} from "../../services/usersService";
import { getFormattedDateTime } from "../../services/dateService";
import AccountSearch from "../common/AccountSearch";

let model = {
  orderNumber: null,
  accountNumber: "",
  orderType: "",
  sampleType: "",
  sampleCount: 0,
  dateReceived: null,
  payType: "",
};

export default function NoBarcodeComponent(props) {
  const [modelInstance, setModelInstance] = useState(model);
  const [currentUser, setCurrentUser] = useState();
  const [time, setTime] = useState(getFormattedDateTime(new Date()));
  const [users, setUsers] = useState([]);
  const [order, setOrder] = useState();
  const [orders, setOrders] = useState([]);
  const [account, setAccount] = useState("");
  const [accountValid, setAccountValid] = useState(false);
  const [etkKits, setEtkKits] = useState(null);
  const [payType, setPayType] = useState("");
  const [accountType, setAccountType] = useState(null);

  useEffect(() => {
    async function loadUsers() {
      let u = await GetUsers("SHIPPING");
      setUsers(u);
    }
    async function loadEktKits() {
      let kits = await GetEtkKits();
      setEtkKits(kits);
    }
    async function loadLastUser() {
      let user = await GetLastUser();
      setCurrentUser(user);
    }

    try {
      loadUsers();
      loadEktKits();
      loadLastUser();
    } catch (err) {
      NotificationManager.error("Error getting the list of users from the API");
    }
  }, []);

  const handleSubmit = async (model) => {
    try {
      setPayType(model.payType);
      model.accountNumber = account;
      setModelInstance(model);
      let response = await CreateOrder(model);
      if (model.payType !== "" && model.orderType === "ETK") {
        setOrders(response);
        NotificationManager.success("Orders created", response.length);
        setOrder(response[0]);
      } else {
        setOrder(response);
        NotificationManager.success("Order created", response.orderNumber);
      }
    } catch (error) {
      appInsights.trackEvent({
        name: "Error Creating New Order",
        properties: {
          message: "Error creating a new order from NoBarcodeMain.js",
          error: error,
        },
      });
      appInsights.trackException({ exception: error });
      NotificationManager.error(
        "Unable to create order. Error " + error,
        "Error Submitting"
      );
    }
  };

  const printSampleBarcodes = async () => {
    if (!modelInstance) return;
    try {
      var sampleIds = GetSampleIdsForOrderSamples(order);

      let sampleInfos = [];

      sampleIds.forEach((id) => {
        let model = Object.create(sampleInfo);

        model.sampleId = id;
        model.sampleType = modelInstance.sampleType;
        sampleInfos.push(model);
      });

      await PrintSampleLabel(sampleInfos);
    } catch (error) {
      appInsights.trackEvent({
        name: "Error Printing Labels for new order",
        properties: {
          message: "Error Printing Labels for new order from NoBarcodeMain.js",
          error: error,
        },
      });
      appInsights.trackException({ exception: error });
      NotificationManager.error(
        "Unable to print labels for order. Error " + error,
        "Error Printing"
      );
    }
  };

  const printCheckIn = async () => {
    try {
      await PrintCheckInLabel(currentUser, new Date(time));
    } catch (error) {
      appInsights.trackEvent({
        name: "Error Printing Labels for new order",
        properties: {
          message: "Error Printing Labels for new order from NoBarcodeMain.js",
          error: error,
        },
      });
      appInsights.trackException({ exception: error });
      NotificationManager.error(
        "Unable to print labels for order. Error " + error,
        "Error Printing"
      );
    }
  };

  const printOrderNumber = async () => {
    try {
      await PrintOrderNumberLabel(order.orderNumber, "orderBarcode", payType);
    } catch (error) {
      NotificationManager.error(
        "Unable to print labels for order. Error " + error,
        "Error Printing"
      );
    }
  };

  // const printOrderNumberQRLabels = async () => {

  // 	const sortedOrders = [...orders].sort((a, b) => b.orderNumber - a.orderNumber);
  // 	sortedOrders.forEach(async (order)=>{
  // 		try {
  // 			await PrintOrderNumberLabel(order.orderNumber, 'orderPayQRBarcode', payType,modelInstance.sampleType);
  // 		} catch (error) {
  // 			NotificationManager.error(
  // 				"Unable to print labels for order. Error " + error,
  // 				"Error Printing"
  // 			);
  // 		}
  // 	})

  // };

  const printOrderNumberQRLabels = async () => {
    try {
      const sortedOrders = [...orders].sort(
        (a, b) => b.orderNumber - a.orderNumber
      );

      // Extract order numbers for batch processing
      const orderNumbers = sortedOrders.map((order) => order.orderNumber);

      // Call the new batch endpoint
      await PrintOrderNumberLabelsBatch(
        orderNumbers,
        "orderPayQRBarcode",
        payType,
        modelInstance.sampleType
      );

      NotificationManager.success(
        "All labels printed successfully",
        "Print Complete"
      );
    } catch (error) {
      NotificationManager.error(
        "Unable to print labels. Error: " + error.message,
        "Error Printing"
      );
    }
  };

  const handleUserChange = (selected) => {
    setCurrentUser(selected);
    SetLastUser(selected);
  };

  const handleReset = () => {
    setModelInstance(model);
    setOrder();
    setAccountValid(account ? true : false);
  };

  return (
    <>
      <div className="container">
        <div className="section">
          <span className="title">
            {modelInstance.orderNumber ?? "New Order"}
          </span>
          <hr />
          <div className="columns">
            <div className="column is-one-third">
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="" className="label">
                    User
                  </label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <select
                      className="input"
                      onChange={(e) => handleUserChange(e.target.value)}
                      value={currentUser}
                    >
                      {users.map((u) => {
                        return (
                          <option key={u} value={u.trim()}>
                            {u.trim()}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="column is-one-third">
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="" className="label">
                    Time
                  </label>
                </div>
                <div className="field-body">
                  <input
                    className="input"
                    type="datetime-local"
                    value={time}
                    onChange={(e) =>
                      setTime(getFormattedDateTime(e.target.value))
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="columns">
            <div className="column is-one-third">
              <div className="field is-horizontal">
                <div className="field-label is-normal">
                  <label htmlFor="" className="label">
                    Account
                  </label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <AccountSearch
                      className={"input"}
                      onChange={(e) => setAccount(e.target.value)}
                      value={account}
                      isValidated={(isValid) => setAccountValid(isValid)}
                      onAccountData={(accountData) => {
                        if (accountData) {
                          setAccountType(accountData.clientType); // or `accountData.accountType`
                        } else {
                          setAccountType(null);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="column has-text-right is-one-third">
              <button className="button is-warning" onClick={handleReset}>
                Reset
              </button>
            </div>
          </div>
          <hr />
          {accountValid && (
            <NewOrderForm
              model={modelInstance}
              kits={etkKits}
              accountNumber={account}
              onSubmit={handleSubmit}
              handlePrint={printSampleBarcodes}
              handlePrintOrderNumber={printOrderNumber}
              handlePrintOrderNumberQRLabels={printOrderNumberQRLabels}
              handleCheckInPrint={printCheckIn}
              orderNumber={order?.orderNumber}
              accountType={accountType}
            />
          )}
        </div>
      </div>
    </>
  );
}
